import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { up, down } from 'slide-element';
import clickOutside from 'click-outside';
import { createFocusTrap } from 'focus-trap';

const $body = document.querySelector('body');
const $searchPanelBtn = document.querySelectorAll('.btn-search-panel');
const $searchPanelCloseBtn = document.querySelector('.btn-close-search-panel');
const $searchPanel = document.querySelector('.search-panel');
const $searchInput = document.querySelector('input[type="search"]');

let unbindClickOutside;
let focusTrap;

const collapseSearchPanel = () => {
    // Remove overlay
    $body.classList.remove('with-overlay');

    // clickOutside
    if (unbindClickOutside) {
        unbindClickOutside();
        unbindClickOutside = null;
    }

    // Deactivate focus trap
    focusTrap.deactivate();

    $searchPanel.setAttribute('aria-hidden', 'true');
    $searchPanelBtn.forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
    });

    // unlock Body scroll
    enableBodyScroll($searchPanel);

    // Close panel
    up($searchPanel);
};

function onEscape(event) {
    if (event.key === 'Escape') {
        collapseSearchPanel();
        window.removeEventListener('keydown', onEscape);
    }
}

const expandSearchPanel = () => {
    // Add overlay
    $body.classList.add('with-overlay');

    // clickOutside
    unbindClickOutside = clickOutside($searchPanel, () => {
        collapseSearchPanel();
    });

    // Initialize and activate focus trap
    setTimeout(() => {
        focusTrap = createFocusTrap($searchPanel, {
            clickOutsideDeactivates: true,
            preventScroll: true,
        });
        focusTrap.activate();
    }, 100);

    $searchPanel.setAttribute('aria-hidden', 'false');
    $searchPanelBtn.forEach((btn) => {
        btn.setAttribute('aria-expanded', 'true');
    });

    $searchInput.focus();

    window.addEventListener('keydown', onEscape);

    // Lock Body scroll
    disableBodyScroll($searchPanel);

    // Close panel
    down($searchPanel, { display: 'flex' });
};

$searchPanelBtn.forEach((btn) => {
    btn.addEventListener('click', (event) => {
        event.stopPropagation();
        if ($searchPanel.getAttribute('aria-hidden') === 'false') {
            collapseSearchPanel();
        } else {
            expandSearchPanel();
        }
    });
});

$searchPanelCloseBtn.addEventListener('click', (event) => {
    event.stopPropagation();
    collapseSearchPanel();
});
